// Vendor Imports
import jQuery from 'jquery';
import * as bootstrap from 'bootstrap'; // import 'bootstrap';



(function ($, bs) {
  console.group('Ontada theme.js');
  console.log('jQuery', $);
  console.log('Bootstrap', bs);
    console.groupEnd();


    // Add toggle grid block component javascript
    const setupToggleGridComponentBlock = () => {
        const $cards = $('.ontada-card');

        const setToggledBlock = (ele) => {
            const $ele = $(ele)
            const textColor = $ele.data("toggled-textcolor")
            const onBgColor = $ele.data("toggled-bgcolor")
            const offBgColor = $ele.data("initial-bgcolor")
            $ele.find(".toggled-text").addClass("show")
            $ele.find(".toggled-text").show();
            $ele.find(".initial-text").hide();
            $ele.addClass(textColor)
            $ele.addClass(onBgColor)
            $ele.removeClass(offBgColor)
        }

        const setUntoggledBlock = (ele) => {
            const $ele = $(ele)
            const textColor = $ele.data("toggled-textcolor")
            const onBgColor = $ele.data("toggled-bgcolor")
            const offBgColor = $ele.data("initial-bgcolor")
            $ele.find(".toggled-text").removeClass("show")
            $ele.find(".toggled-text").hide();
            $ele.find(".initial-text").show();
            $ele.removeClass(textColor)
            $ele.removeClass(onBgColor)
            $ele.addClass(offBgColor)
        }

        $cards.hover(
            function () {
                setToggledBlock(this)
            },
            function () {
                setUntoggledBlock(this)

            }
        )
        // Mobile
        $cards.on('click focus', function () {
            setToggledBlock(this)
        }).on('blur', function () {
            setUntoggledBlock(this)

        })
    }
    setupToggleGridComponentBlock();

    $(document).ready(() => updateComponentHeight())
    $(window).on('resize', () => updateComponentHeight());

    function updateComponentHeight() {

        var spreadHighest = (parent, selector) => {
            var highest = 0;
            var elements = parent.find(selector)
            elements.each(function () {
                var height = $(this).height();
                if (height > highest) {
                    highest = height;
                }
            });
            elements.height(highest);
        };

        var parent = $('.redesigned-content-block');
        spreadHighest(parent, '.segment-layout-column .redesigned-content-block-eyebrow');
        spreadHighest(parent, '.segment-layout-column .title');
    }
    

})(jQuery, bootstrap);

